import { lazy, useEffect } from "react";
import { LazyMount } from "@/components/site/LazyMount";
import useLenis from "@/hooks/useLenis";
import { setHreflang } from "@/lib/seo";
import { UpdatedAsOn, DailyPulseBar, DailyPulseCards, BriefPlayer } from "@/components/site/Freshness";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { DailyPulse } from "@/components/site/DailyPulse";
import { CiLeadCapture } from "@/components/site/CiLeadCapture";
const Manifesto = lazy(() => import("@/components/site/Manifesto").then((m) => ({ default: m.Manifesto })));
const BrandFilm = lazy(() => import("@/components/site/BrandFilm").then((m) => ({ default: m.BrandFilm })));
const CaseStudies = lazy(() => import("@/components/site/CaseStudies").then((m) => ({ default: m.CaseStudies })));
const InsightsTeaser = lazy(() => import("@/components/site/InsightsTeaser").then((m) => ({ default: m.InsightsTeaser })));
const Stats = lazy(() => import("@/components/site/Stats").then((m) => ({ default: m.Stats })));
const Services = lazy(() => import("@/components/site/Services").then((m) => ({ default: m.Services })));
const Approach = lazy(() => import("@/components/site/Approach").then((m) => ({ default: m.Approach })));
const Partners = lazy(() => import("@/components/site/Partners").then((m) => ({ default: m.Partners })));
const Faq = lazy(() => import("@/components/site/Faq").then((m) => ({ default: m.Faq })));
const BessCalculator = lazy(() => import("@/components/site/BessCalculator").then((m) => ({ default: m.BessCalculator })));
const BrochureDownload = lazy(() => import("@/components/site/BrochureDownload").then((m) => ({ default: m.BrochureDownload })));
const LinkedInFeed = lazy(() => import("@/components/site/LinkedInFeed").then((m) => ({ default: m.LinkedInFeed })));
const Contact = lazy(() => import("@/components/site/Contact").then((m) => ({ default: m.Contact })));
const LifeTeaser = lazy(() => import("@/components/site/LifeTeaser").then((m) => ({ default: m.LifeTeaser })));
const GalleryTeaser = lazy(() => import("@/components/site/GalleryTeaser").then((m) => ({ default: m.GalleryTeaser })));
import { SiteFooter } from "@/components/site/SiteFooter";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { MarketPulseStrip } from "@/components/site/MarketPulseStrip";
import { CommodityTicker } from "@/components/site/CommodityTicker";
const DealsPulse = lazy(() => import("@/components/site/DealsPulse").then((m) => ({ default: m.DealsPulse })));
const TariffPulse = lazy(() => import("@/components/site/TariffPulse").then((m) => ({ default: m.TariffPulse })));
const DprTevSection = lazy(() => import("@/components/site/DprTevSection").then((m) => ({ default: m.DprTevSection })));
const OemTicker = lazy(() => import("@/components/site/OemTicker").then((m) => ({ default: m.OemTicker })));
import { FreshToday } from "@/components/site/FreshToday";
import { WishCarousel } from "@/components/site/WishCarousel";
const SaasSuiteCta = lazy(() => import("@/components/site/SaasSuiteCta").then((m) => ({ default: m.SaasSuiteCta })));

export default function Home() {
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/i18n/hi/pages/home`).then((r) => setHreflang(r.ok ? [{ lang: "en-IN", href: "https://growthifye.com/" }, { lang: "hi-IN", href: "https://growthifye.com/hi" }, { lang: "x-default", href: "https://growthifye.com/" }] : [])).catch(() => setHreflang([]));
  }, []);
  useLenis();
  return (
    <>
      <Navbar />
      <div className="pt-[72px]"><DailyPulseBar /></div>
      <main>
        <Hero />
        <WishCarousel />
        <FreshToday />
        <DailyPulse />
        <MarketPulseStrip />
        <CommodityTicker />
        <CiLeadCapture />
        <LazyMount><DealsPulse /></LazyMount>
        <LazyMount><TariffPulse /></LazyMount>
        <LazyMount><OemTicker /></LazyMount>
        <LazyMount><Services /></LazyMount>
        <LazyMount><SaasSuiteCta /></LazyMount>
        <LazyMount><DprTevSection /></LazyMount>
        <LazyMount><BessCalculator /></LazyMount>
        <LazyMount><Manifesto /></LazyMount>
        <LazyMount><BrandFilm /></LazyMount>
        <LazyMount><Stats /></LazyMount>
        <LazyMount><CaseStudies /></LazyMount>
        <LazyMount><InsightsTeaser /></LazyMount>
        <LazyMount><LifeTeaser /></LazyMount>
        <LazyMount><Approach /></LazyMount>
        <LazyMount><Partners /></LazyMount>
        <LazyMount><Faq /></LazyMount>
        <LazyMount><BrochureDownload /></LazyMount>
        <LazyMount><LinkedInFeed /></LazyMount>
        <LazyMount><GalleryTeaser /></LazyMount>
        <LazyMount><Contact /></LazyMount>
      </main>
      <DailyPulseCards />
      <SiteFooter />
      <WhatsAppButton />
    </>
  );
}
